<template>
<body id="page-top" class="body-bg">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio certificate-login-section" id="portfolio">
            <div class="container">
              <form @submit.prevent="handleSubmit">
                <div>
               <iframe id="shopIframe" class="form-iframe" src="https://shop.philcare.com.ph/" crossorigin="anonymous"></iframe>
        </div>

               <div class="col-md-12 iframe-back-btn">
                  <router-link to="/member-page"><a style="float:left" type="button" class="btn btn-primary btn-lg">BACK</a></router-link>
            </div>
            </form>
             </div> 

             

        </section>
</body>
</template>

<script>
export default {
  name: 'PhilLogin',
  data() {
    return {

    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
